module.exports = __webpack_public_path__ + "static/media/img_map@2x.b0e478b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_map@2x.png
// module id = 869
// module chunks = 0